import React from "react";
import PropTypes from "prop-types";
import { gatherClasses } from "../../lib/utils";

const Tag = ({ onRemove, label, value, isDisabled }) => (
  <div className="oui-tagsel-tag">
    <div className="oui-tagsel-text-content">
      {label && <span className="oui-tagsel-tag-label">{label}</span>}
      {value}
    </div>
    <div
      className={gatherClasses(
        null,
        "oui-tagsel-remove",
        isDisabled && "oui-tagsel-remove--disabled"
      )}
      onClick={isDisabled ? null : onRemove}
      aria-hidden="true"
    >
      <svg
        height="14"
        width="14"
        viewBox="0 0 20 20"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" />
      </svg>
    </div>
  </div>
);

Tag.propTypes = {
  onRemove: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.string,
  isDisabled: PropTypes.bool
};

export default Tag;
